<template>
  <div>
    <!-- <SmallSquare content="1、消息订阅：可通过站内信或手机接收关注的节点动态；若启用手机短信订阅，请确保账户短信充足。查看短信余额
2、部分消息支持数据助手工资号推送，请先关注“大数据引擎助手”公众号，绑定微信号后设置开启推送。" />
    <div class='m-b-48 m-t-80 s_flex_ali'>
      <span class='mr15'>
        <a-button type="primary" @click="allSet">
          <PlusOutlined />
          一次性订阅
        </a-button>
      </span>
    </div> -->
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a v-has:miniTemplateAdd="()=>add(record)" href="javascript:;">添加</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </div>
</template>
<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { inject, reactive, ref, toRefs } from "vue";
  import { getMiniappTmpLibrary, createMiniappTmp } from "@/api/message.js";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
  };
  export default {
    components: { DownOutlined },
    setup(props, { emit }) {
      let columns = [

        {
          title: "标题",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "关键词",
          dataIndex: "keywords",
          key: "keywords",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const state = reactive({
        receiverVisible: false,
        confirmLoading: false,
      })

      const $Modal = inject('$Modal')
      const router = inject('$router')
      //初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      let listLoading = ref(false);
      let data = ref([]);
      let total = ref(0)
      const initData = async (values) => {
        listLoading.value = true;
        let res = await getMiniappTmpLibrary(values).then((res) => res.data);
        listLoading.value = false;
        data.value = res.data.data;
        total.value = res.data.total
      };
      initData(search.value)
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const add = async (data) => {
        let res = await createMiniappTmp({ template_id: data.id }).then((res) => res.data);
        iscode(res, true)
        emit('success')
      }
      return {
        columns,
        listLoading,
        pageCurrentChange,
        pageSizeChange,
        search,
        data,
        total,
        ...toRefs(state),
        add
      };
    },
  };
</script>